import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

function Contact() {
  return (
    <section className="w-full bg-gradient-to-r from-blue-100 to-blue-300 py-2 px-6">

      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">

        {/* LEFT SIDE */}
        <div>

          {/* <p className="text-orange-500 font-semibold tracking-widest mb-4">
            LET'S GET STARTED!
          </p> */}

          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            <span className="text-blue-900">Reach us</span>
          </h2>

          <p className="text-lg text-gray-700 mb-8">
            Best Place to Learn
          </p>

          <div className="space-y-6">

            <div className="flex items-center gap-4">
              <div className="bg-black text-white p-3 rounded-full">
                <FaPhoneAlt />
              </div>
              <p>+91-91234 56789</p>
            </div>

            <div className="flex items-center gap-4">
              <div className="bg-black text-white p-3 rounded-full">
                <FaEnvelope />
              </div>
              <p>info@avyb.com</p>
            </div>

            <div className="flex items-center gap-4">
              <div className="bg-black text-white p-3 rounded-full">
                <FaMapMarkerAlt />
              </div>
              <p>
                Plot No : 247/A , Chanda Nagar,  
                Hyderbad.
              </p>
            </div>

          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="bg-white text-black rounded-2xl p-10 shadow-xl">

          <span className="bg-blue-600 px-4 py-1 rounded-full text-white">
            Let's Get Connect!
          </span>

          <h3 className="text-lg mt-4 mb-8">
            Send us a message, and we'll reach you.
          </h3>

          <form className="space-y-6">

            <div className="grid grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Full Name"
                className="bg-transparent border-b border-gray-600 outline-none pb-2"
              />
{/* 
              <input
                type="text"
                placeholder="Company Name"
                className="bg-transparent border-b border-gray-600 outline-none pb-2"
              /> */}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Mobile Number"
                className="bg-transparent border-b border-gray-600 outline-none pb-2"
              />

              {/* <input
                type="email"
                placeholder="Email Address"
                className="bg-transparent border-b border-gray-600 outline-none pb-2"
              /> */}
            </div>

            {/* <input
              type="text"
              placeholder="Select Services"
              className="w-full bg-transparent border-b border-gray-600 outline-none pb-2"
            /> */}

            <textarea
              placeholder="How can we help you?"
              className="w-full bg-transparent border-b border-gray-600 outline-none pb-2"
            />

            <button
              className="w-full bg-gradient-to-r from-blue-100 to-blue-300 text-blue font-semibold py-3 rounded-lg mt-4 hover:opacity-90"
            >
              INQUIRE NOW →
            </button>

          </form>

        </div>

      </div>

    </section>
  );
}

export default Contact;